import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { AlertService, UserService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { PrinterSetupService } from 'sce-home';
import { ReportParam } from './jreport-param-model';
import { DetailViewKeyEventHandlerService } from '../../services/detail-view-key-event-handler.service';
import { ViewReportDataEditorService } from '../../../features/control/inventory/view-report/services/viewreport-data-editor.service';
import { ModalService } from '../../services/modal.service';
import { DatePickerConfigService } from '../../components/datepicker/datepicker-config.service';
import { DetailedEntityDataService } from '../../services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { SearchService } from '../../search/search.service';

@Component({
  selector: 'lfwms-jreport-lookup',
  templateUrl: './jreport-lookup.component.html',
  styleUrls: ['./jreport-lookup.component.css']
})
export class JreportLookupComponent implements OnInit {

  public reportDefaultValues: any;
  public fieldsToPrintReport = {};
  public printerIds: any;
  public title: string = '';
  public userInputFields: any;
  public showPage = false;
  public printerparameter = [];
  public reportTypes = [];
  public enableSubmitButton = false;
  public typeSelected: any;
  public selectedPaperPrinter: any;
  public isPresentList = [];
  public norPresentList = [];
  public reportInputParams = [];
  public existingValues = [];
  public primaryDataMap: any;
  public defaultPrinters: any;
  public printEventSubject = new Subject<any>();
  public printReqData = {
    printerID: '',
    isPaperPrinter: 'Y',
    noOfCopy: 1
  };
  public maxParameter: number = 5;
  private showKeyValueParams: boolean = false;
  public reportConfig: any;
  public dataEditor: ViewReportDataEditorService;
  public paramList: Array<ReportParam> = []; // contains both KeyField and Extended Prameter details
  public reportSource: string = 'DocReport';
  public keyFieldList: Array<ReportParam> = [];
  public facilityMetaData: any; // to set the facility option values
  public keyEventHandler: DetailViewKeyEventHandlerService;
  public offset: number = 0;
  public dateFormat: string;
  public dateTimeFormat: string;
  public parentDataService: DetailedEntityDataService;
  public minReceiptLineNumber: string = ''; // [LFWM-1980] - first receipt line item number of records in server side
  public maxReceiptLineNumber: string = ''; // [LFWM-1980] -  last receipt line item number of records in server side
  /* [LFWM-1981] -  false - if print functionality from ASN, Trade Returns, Inbound XDock and Outbound XDock Screens, Wave Control, Inventory QC,
   * [if selected rows count from detail > 0] */
  public printFromHeader: boolean = true;
  public receiptLineNumberConfigArray = []; // [LFWM-1980] - used to store the key of selectedReportConfig [if key = receiptLineNumber]
  public existingValuesArray = []; // [LFWM-1981] -  if selected line items count > 0, then storer the existingValues is an Array to send the backend.
  /* [LFWM- 1981, 2027] - detail table id list in which the detail level print is enabled.. */
  public tableIdsDetailLevelPrintEnabled = [
    'asndetailtd',
    'trdetailtd',
    'xdockdetailtd',
    'wavecntrlwaveodrtd',
    'wavecntrlldodrtd',
    'wavecntrlmbolodrtd',
    'invqcdetailtd',
    'shiprefdetailtd'
  ];
  public tableSearchServiceForWaveControl: SearchService;
  public selectedRows: any = [];
  public tableId: string;
  public showParamSection: boolean = false; // true - after selecting report type

  constructor(public modalService: ModalService,
    public resourceService: ResourceService,
    private printerSetupService: PrinterSetupService,
    private alertService: AlertService,
    private dateConfigService: DatePickerConfigService,
    private userService: UserService) {
    this.printEventSubject = new Subject<any>();
  }

  ngOnInit() {
    this.dateFormat = this.dateConfigService.defaultDateDisplayFormat;
    this.dateTimeFormat = this.dateConfigService.defaultDateDisplayFormat + ' ' + this.dateConfigService.defaultTimeDisplayFormat;
   // this.fetchDefaultPrinters();
  }

  /* reportConfig - report details with parameters
    * inputValues - contain documentType,  storerKey, facility from parent screen [documentTpe - primaryTableId]
    * printerIds - default labelPrinter and paperPrinter of the logged in user. already set in set default printer screen
    * showKeyValueParams - true - if reportSource is ViewReport
    * dataService - dataService instance from parent screen
    * tableSearchService - for wave control screen - because wave control has more than one detail search service and detail table */
  public setInitialData(reportConfig: any, inputValues: any, printerIds: any, primaryDataMap: any,
    showKeyValueParams: any, reportSource: any, dataService: DetailedEntityDataService, tableSearchService: any) {
    this.reportConfig = reportConfig;
    this.userInputFields = reportConfig;
    this.reportDefaultValues = inputValues;
    this.printerIds = printerIds;
    this.reportTypes = reportConfig.reportList;
    this.primaryDataMap = primaryDataMap;
    this.printReqData.printerID = this.printerIds['paperPrinter'];
    this.showPage = false;
    this.showKeyValueParams = showKeyValueParams;
    this.reportSource = reportSource;
    this.parentDataService = dataService;
    this.tableSearchServiceForWaveControl = tableSearchService;

    if (this.reportTypes && this.reportTypes.length === 1) {
      this.typeSelected = this.reportTypes[0].cVal;
      this.reportTypeChanged();
    }
  }

  public setDataTableEditor(tableEditor: any, keyEventHandler: any) {
    if (tableEditor) {
      this.dataEditor = tableEditor;
      this.keyEventHandler = keyEventHandler;
    }
  }

  public paperPrinterChanged() {
    if (this.printReqData.isPaperPrinter === 'Y') {
      this.printReqData.printerID = this.printerIds['paperPrinter'];
    } else {
      this.printReqData.printerID = this.printerIds['labelPrinter'];
    }
    // [LFWM-2223][UAT - TW | Set Default Printer does NOT work][changes reflect when paper printer is changed] 
    this.selectedPaperPrinter = this.printReqData.printerID;
  }

  public reportTypeChanged() {
    if (this.typeSelected) {
      this.enableSubmitButton = true;

      const selectedReportConfig = this.getSelectedReportConfig();
      if (selectedReportConfig) {
        this.showParamsForSelectedReport(selectedReportConfig);
      }
      this.showPage = true;

      /* [LFWM-1981] - As of now print from detail is implemented for ASN, Trade Returns, Inbound XDock and Outbound XDock, Inventory QC */
      if(this.parentDataService.detailsSearchParams){
        if (this.parentDataService && this.parentDataService.primarySearchParams &&
          this.tableIdsDetailLevelPrintEnabled.indexOf(this.parentDataService.detailsSearchParams.tableId) !== -1) {
          this.tableId = this.parentDataService.detailsSearchParams.tableId;
          this.printFromHeader = this.parentDataService.detailsSearchService.getSelectedRows().length === 0 ? true : false;
          if (!this.printFromHeader) {
            this.selectedRows = this.parentDataService.detailsSearchService.getSelectedRows();
          }
        }
      }
     

      /* [LFWM-2027] - print from detail is enabled for Wave Control Screen all three tabs -[wave, load, shipRef] */
      if (this.tableSearchServiceForWaveControl && this.tableSearchServiceForWaveControl.searchParams &&
        this.tableIdsDetailLevelPrintEnabled.indexOf(this.tableSearchServiceForWaveControl.searchParams.tableId) !== -1) {
        this.tableId = this.tableSearchServiceForWaveControl.searchParams.tableId;
        this.printFromHeader = this.tableSearchServiceForWaveControl.getSelectedRows().length === 0 ? true : false;
        if (!this.printFromHeader) {
          this.selectedRows = this.tableSearchServiceForWaveControl.getSelectedRows();
        }
      }

      /* [LFWM-1980] - if the user doesn't select any line items then the print is consider as print from header level
      otherwise it is print from detail level */
      if (this.printFromHeader && this.parentDataService && this.parentDataService.primarySearchParams &&
        this.parentDataService.primarySearchParams.idProperty === 'receiptKey') {
        for (const key of Object.keys(selectedReportConfig.keyFieldNameWithoutLabel)) {
         // if (selectedReportConfig.keyFieldNameWithoutLabel[key] === 'receiptLineNumber') {
            this.receiptLineNumberConfigArray.push(key);
         // }
        }
        /* [LFWM-1980] - for ASN, Trade Returns, Inbound XDock, Outbound XDock - printFromHeader - true - if receiptLineNumber
           exist in selectedReportConfig and selectedRows count zero,
           than need to fetch first and last receipt line number of records available in server side.
           no.of line item count - 0 - first and last line number is passed as null.
           no.of line item count - 1 -  first receiptLineNumber is assigned for both first and last line number */
        // if (this.receiptLineNumberConfigArray.length > 0) {
        //   this.printerSetupService.getMinMaxOfLineItems(this.primaryDataMap['receiptKey'].cVal).subscribe(resp => {
        //     if (resp) {
        //       this.minReceiptLineNumber = resp['minReceiptLineNumber'] !== '0' ? resp['minReceiptLineNumber'] : '';
        //       this.maxReceiptLineNumber = resp['maxReceiptLineNumber'] !== '0' ? resp['maxReceiptLineNumber'] : '';
        //     }
        //   }, (error) => {
        //     this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
        //   });
        // }
      }
    } else {
      this.enableSubmitButton = false;
      this.showPage = false;
    }
  }

  private getSelectedReportConfig() {
    let selectedReportConfig = null;
    if (this.reportSource === 'DocReport') {
      this.userInputFields.reportDetailMapList.forEach((report: any) => {
        if (report[this.typeSelected]) {
          selectedReportConfig = report[this.typeSelected];
        }
      });
    } else if (this.reportSource === 'ViewReport') {
      if (this.userInputFields && this.userInputFields.reportDetailMapList.reportId === this.typeSelected) {
        if (this.userInputFields.reportDetailMapList.reportParamMap) {
          selectedReportConfig = this.userInputFields.reportDetailMapList.reportParamMap;
        }
      }
    }
    return selectedReportConfig;
  }

  public submitPrintJob(reportInput: any, printerInput: any) {
    this.existingValues = [];
    // Adding this logic so as to bind the keyfield params which are not used in display but need to send
    // along the report input params to the backend service
    if (this.primaryDataMap) {
      if (this.paramList && this.paramList.length > 0) {
        this.paramList.forEach((param: any) => {
          if (param.type === 'keyfieldparamwithoutlabel') {
            if (this.primaryDataMap[param.cVal]) {
              this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': this.primaryDataMap[param.cVal].cVal });
            } else {
              this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': '' });
            }
          } else {
            // type - extendedParam or keyfieldparamwithlabel.
            this.existingValues.push({ 'key': param.key, 'Value': param.label, 'uservalue': param.cVal });
          }
        });
      }
     }

    this.fieldsToPrintReport = [{
      documentType: this.reportDefaultValues.documentType,
      reportID: this.typeSelected,
      storerkey: this.reportDefaultValues.storer,
      facility: this.reportDefaultValues.facility,
      computerName: '',
      printerID: '',
      noOfCopy: 1,
      isPaperPrinter: 'Y',
      printParams: this.getPrintParams(reportInput, this.existingValues),
      printSource: 'JReport'
    }];
    
    // LFWMS -2023 for viewReport screen,no need to push fields of viewReport into array
    this.jReportprintReportNotifyEvent(this.fieldsToPrintReport);
  }

  // method to format the existingparam
  public getPrintParams(reportInput: any, existingparam: any) {
    const printparams = [];
    existingparam.forEach((param: any) => {
      printparams.push({
        'keyField': param.key,
        'displayLabel': param.Value,
        'value': param.uservalue
      });
    });
    return printparams;
  }

  private jReportprintReportNotifyEvent(value: any) {
    this.printEventSubject.next(value);
  }

  public jReportprintReportReceiveEvent(): Observable<any> {
    return this.printEventSubject.asObservable();
  }


  // method to modify the parameters of selected report in a required format
  public showParamsForSelectedReport(selectedReportConfig: any) {
    this.paramList = [];
    if (this.showKeyValueParams) {
      this.showParamSection = true;
      // for report config - ViewReport - print from View Report screen
      Object.keys(selectedReportConfig).forEach(param => {
        this.paramList.push(
          {
            'key': param, 'label': selectedReportConfig[param].ParmLabel, 'cVal': selectedReportConfig[param].DefaultVal,
            'disable': false, 'dataType': selectedReportConfig[param].DataType
          }
        );
        if (this.isFacilityField(selectedReportConfig[param].ParmLabel)) {
          if (!this.facilityMetaData) {
            this.facilityMetaData = [];
            this.printerSetupService.getFacilityValues().subscribe((resp: any) => {
              if (resp) {
                this.facilityMetaData = resp;
              }
            }, (error) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
            });
          }
        }
      });
    } else { // for report config - DocReport - print from all the screens except View Report
      // array of key field parameters with label and value which should be displayed
      const keyFieldParmListWithLabelAndValue = selectedReportConfig.keyFieldParmLabelAndValue;
      // array of key field parameters without label and need not to display but need to append this in request along with input params
      const keyFieldParmListWithoutLabel = selectedReportConfig.keyFieldNameWithoutLabel;
      // array of key extended parameters with label and value which should be displayed
      const extendedParamList = selectedReportConfig.extendedParmAndDefaultValue;
      for (let i = 0; i < keyFieldParmListWithLabelAndValue.length; i++) {
        // type - added for - to identify the value should be taken from the parent screen or from the config
        // if the parmValue is available in the parent screen [EX: ASN - receiptKey] then the value of that field should be assigned in cVal.
        if (this.primaryDataMap[keyFieldParmListWithLabelAndValue[i].parmValue]) {
          this.paramList.push(
            {
              'key': keyFieldParmListWithLabelAndValue[i].parmKey, 'label': keyFieldParmListWithLabelAndValue[i].parmLabel,
              'cVal': this.primaryDataMap[keyFieldParmListWithLabelAndValue[i].parmValue].cVal, 'disable': true,
              'dataType': 'String', 'show': true, 'type': 'keyfieldparamwithlabel'
            });
        } else {
          /* if the parmValue is not available in the parent screen then the default value is assigned in cVal.
          this field is editable user can change the value */
          this.paramList.push(
            {
              'key': keyFieldParmListWithLabelAndValue[i].parmKey, 'label': keyFieldParmListWithLabelAndValue[i].parmLabel,
              'cVal': keyFieldParmListWithLabelAndValue[i].parmValue, 'disable': false,
              'dataType': 'String', 'show': true, 'type': 'keyfieldparamwithlabel'
            });
        }
      }
      // keyFieldParmListWithoutLabel - need not to display but need to append in request
      for (const key of Object.keys(keyFieldParmListWithoutLabel)) {
        this.paramList.push(
          {
            'key': key, 'label': '', 'cVal': keyFieldParmListWithoutLabel[key],
            'dataType': 'String', 'show': false, 'type': 'keyfieldparamwithoutlabel'
          });
      }
      // extended param is displayed with default value from config. and user can edit the field
      if (selectedReportConfig.needExtendedParm === 'Y') {
        for (let i = 0; i < extendedParamList.length; i++) {
          this.paramList.push(
            {
              'key': extendedParamList[i].parmKey, 'label': extendedParamList[i].parmLabel, 'cVal': extendedParamList[i].parmValue,
              'disable': false, 'show': true, 'dataType': 'String', 'type': 'extendedParam'
            });
        }
      } else {
        // needExtendedParm - N - no need to disply but need to send the values in request
        for (let i = 0; i < extendedParamList.length; i++) {
          this.paramList.push(
            {
              'key': extendedParamList[i].parmKey, 'label': extendedParamList[i].parmLabel, 'cVal': extendedParamList[i].parmValue,
              'show': false, 'dataType': 'String', 'type': 'extendedParam'
            });
        }
      }
      // parameters section should be shown if no.of displayed parameter is more than 0.
      const paramListToDisplay = this.paramList.filter(param => param.show === true);
      if (paramListToDisplay.length > 0) {
        this.showParamSection = true;
      } else {
        this.showParamSection = false;
      }
    }
  }

  private fetchDefaultPrinters() {
    this.printerSetupService.fetchDefaultPrinters()
      .subscribe((resp: any) => {
        if (resp['statusCode'] && resp['statusMessage']) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            this.defaultPrinters = resp['printerDetails'];
            /**
             * if default printer is available in response it should be auto populated
             */
            if (resp['defaultPrinterDetails'] && resp['defaultPrinterDetails']['printerId']) {
              this.selectedPaperPrinter = resp['defaultPrinterDetails']['printerId'];
            }
            // [LFWM-2223][UAT - TW | Set Default Printer does NOT work][set default parameter if available]
            if (this.selectedPaperPrinter === null || this.selectedPaperPrinter === undefined || this.selectedPaperPrinter === '') {
              this.selectedPaperPrinter =  this.userService.userInfo.defaultPrinter.paperPrinter;
            }
          }
        } else {
          if (resp.error) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(resp.error));
          }
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
  }
  public onChange() {
    this.alertService.clearAll();
  }

  public onValueChangeInTypeaheadTextBox(event: any, field: any) {
    field.cVal = event.target.value;
  }

  public isStorerField(label: any) {
    let storerFlag: boolean;
    storerFlag = label.includes('storer') || label.includes('Storer');
    return storerFlag;
  }
  public isFacilityField(label: any) {
    let facFlag: boolean;
    facFlag = label.includes('facility') || label.includes('Facility');
    return facFlag;
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/jreport-lookup/jreport-lookup.component.ts